import BaseDataProvider from "./BaseDataProvider";

export class CommonDataProvider extends BaseDataProvider {
    _getFullObject(context = {}) {
        return 13216;
    }

    getScrollObject(context) {
        return super.getScrollObject(context);
    }

    __getNumFromInfo(info) {
        let num = 0;

        Object.values(info).forEach((inf) => {
            num += inf[1];
        });

        return num;
    }

    getNum(context) {
        console.log(context.screen);
        const info = this.getBlocksInfo(context);
        return this.__getNumFromInfo(info);
    }

    getScrollNum(context) {
        const info = this.getScrollBlocksInfo(context);
        return this.__getNumFromInfo(info);
    }

    // GET BLOCKS INFO START
    getBlocksInfo(context) {
        const frpVersionToGetBlocksInfo = {
            11: this._getBlocksInfo_11,
        };

        const getBlocksInfo = frpVersionToGetBlocksInfo[context.fprVersion] || this._getBlocksInfo_default;

        return getBlocksInfo(context);
    }

    _getBlocksInfo_default(context) {
        const s320 = {
            top: [0, 2],
            intext: [0, 1],
            lookAlso: [0, 2],
        };

        const s480 = {
            top: [0, 2],
            intext: [0, 1],
            lookAlso: [0, 2],
        };

        const s720 = {
            top: [0, 2],
            intext: [0, 1],
            lookAlso: [0, 2],
        };

        const s960 = {
            top: [0, 2],
            intext: [0, 1],
            lookAlso: [0, 2],
        };

        const s1280 = {
            top: [0, 2],
            intext: [0, 1],
            lookAlso: [0, 2],
        };

        return {
            320: s320,
            480: s480,
            720: s720,
            960: s960,
            1280: s1280,
        }[context.screen];
    }

    _getBlocksInfo_11(context) {
        return {
            lookAlso: [0, 2],
        };
    }
    // GET BLOCKS INFO END

    // GET SCROLL BLOCKS INFO START
    getScrollBlocksInfo(context) {
        const frpVersionToGetScrollBlocksInfo = {};

        const getScrollBlocksInfo =
            frpVersionToGetScrollBlocksInfo[context.fprVersion] || this._getScrollBlocksInfo_default;

        return getScrollBlocksInfo(context);
    }

    _getScrollBlocksInfo_default(context) {
        const s320 = {
            data1: [0, 2],
            data2: [0, 3],
            data3: [0, 2],
        };

        const s480 = {
            top: [0, 2],
            left: [0, 3],
        };

        const s720 = {
            top: [0, 3],
            left: [0, 5],
            right: [0, 3],
        };

        const s960 = {
            top: [0, 3],
            left: [0, 5],
            right: [0, 6],
        };

        const s1280 = {
            top: [0, 4],
            left: [0, 5],
            right: [0, 6],
        };

        return {
            320: s320,
            480: s480,
            720: s720,
            960: s960,
            1280: s1280,
        }[context.screen];
    }
    // GET SCROLL BLOCKS INFO END

    async loadInitialData(context, scrollNum) {
        const num = this.getNum(context);
        const object = this.getObject(context);
        const teasers = await this.load(object, num, context, scrollNum);

        const data = this.spliceData(teasers, this.getBlocksInfo(context) || {});

        const scrollData = [];
        return { data, scrollData };
    }

    async loadScrollData(context, scrollNum) {
        const num = this.getScrollNum(context);
        const object = this.getScrollObject(context);
        const teasers = await this.load(object, num, context, scrollNum);
        const scrollData = [this.spliceData(teasers, this.getScrollBlocksInfo(context))];
        return { scrollData };
    }
}

export default new CommonDataProvider(); 